import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';
import { JSX } from 'react/jsx-runtime';

const ArrowRight = (
  props: JSX.IntrinsicAttributes &
    Omit<
      React.SVGProps<SVGSVGElement>,
      'as' | 'translate' | keyof IconProps
    > & { htmlTranslate?: 'yes' | 'no' | undefined } & IconProps & {
      as?: 'svg' | undefined;
    }
) => {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      boxSize='18px'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <line x1='5' y1='12' x2='19' y2='12'></line>
      <polyline points='12 5 19 12 12 19'></polyline>
    </Icon>
  );
};

export default ArrowRight;
